
		<div class="auth0-callback-spinner">
			<spinner-loading [isLoading]="true" [loadingText]="'Signing you in…'"></spinner-loading>
			<div *ngIf="error" class="text-danger p-3">{{ error }}</div>
		</div>
	